jQuery(() =>
  window.dataLayer.push({
    event: 'VirtualPageview',
    virtualPageURL: window.location.href,
    virtualPageTitle: document.title,
    virtualPagePath: window.location.pathname
  })
);
